import React, { useState, useEffect } from "react";
import "./VistaProcesos.css";
import AADService from "../funcionesAuth.js";

const VistaProcesos = () => {
  const AzureADService = new AADService();
  const token = AzureADService.getToken();
  const PROCESOS = [
    { id: 1, nombre: "Generación alertas" },
    { id: 2, nombre: "Informe general completo" },
    { id: 3, nombre: "Actualización desde CMDB" },
    { id: 4, nombre: "Actualización findings masivo" },
    { id: 5, nombre: "Modelo masivo" },
    { id: 6, nombre: "Criticidad ACIs masiva" },
  ];

  const COMPANIAS = [
    { id: 0, nombre: "Global" },
    { id: 1, nombre: "Bancolombia" },
    { id: 2, nombre: "Nequi" },
    { id: 3, nombre: "BAM" },
    { id: 4, nombre: "Banco Agrícola" },
    { id: 5, nombre: "Banistmo" },
  ];

  const [selectedProceso, setSelectedProceso] = useState("");
  const [selectedCompania, setSelectedCompania] = useState("");
  const [ultimaEjecucion, setUltimaEjecucion] = useState(null);
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL;

  const fetchData = async (url, setter) => {
    try {
      const resp = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      });
      if (resp.ok) {
        const data = await resp.json();
        setter(data);
      } else {
        let detail = "";
        try {
          const errJson = await resp.json();
          detail = errJson?.detail || JSON.stringify(errJson);
        } catch {}
        throw new Error(`Error ${resp.status} ${detail}`);
      }
    } catch (err) {
      console.error("Error en fetchData:", err);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchUltimaEjecucion = async () => {
    if (!selectedProceso) return;

    try {
      const resp = await fetch(
        `${API_URL}administrador/procesos/${selectedProceso}/0/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + token
          },
        }
      );

      if (!resp.ok) {
        throw new Error("Error obteniendo última ejecución");
      }

      const data = await resp.json();

      let fechaFinal = null;

      if (typeof data === "string") {
        fechaFinal = data;
      } else if (typeof data === "object" && selectedCompania !== "") {
        fechaFinal = data[selectedCompania] || null;
      }

      setUltimaEjecucion(fechaFinal);
    } catch (err) {
      console.error("Error en fetchUltimaEjecucion:", err);
      setUltimaEjecucion(null);
    }
  };

  const fetchLogs = async () => {
    fetchData(`${API_URL}administrador/procesos/0/0/`, setLogs);
  };

  const ejecutarProceso = async () => {
    setLoading(true);
    try {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => {
        controller.abort();
        fetchLogs();
      }, 3000);

      const resp = await fetch(
        `${API_URL}administrador/procesos/${selectedProceso}/${selectedCompania}/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: "Bearer " + token
          },
          signal: controller.signal,
        }
      );

      clearTimeout(timeoutId);

      if (resp.ok) {
        const data = await resp.json();
        console.log("Proceso ejecutado:", data);
      } else {
        let detail = "";
        try {
          const errJson = await resp.json();
          detail = errJson?.detail || JSON.stringify(errJson);
        } catch {}
        throw new Error(`Error ${resp.status} ${detail}`);
      }
    } catch (err) {
      if (err.name === "AbortError") {
        console.warn("La petición fue abortada (timeout).");
      } else {
        console.error("Error en ejecutarProceso:", err);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="vp-root">
      <div className="vp-toolbar">
        <div className="vp-toolbar-left">
          <div className="vp-field">
            <label>Proceso</label>
            <select
              value={selectedProceso}
              onChange={(e) => setSelectedProceso(e.target.value)}
            >
              <option value="">Seleccione Proceso</option>
              {PROCESOS.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.nombre}
                </option>
              ))}
            </select>
          </div>

          <div className="vp-field">
            <label>Compañía</label>
            <select
              value={selectedCompania}
              onChange={(e) => setSelectedCompania(e.target.value)}
            >
              <option value="">Seleccione Compañía</option>
              {COMPANIAS.map((c) => (
                <option key={c.id} value={c.id}>
                  {c.nombre}
                </option>
              ))}
            </select>
          </div>

          <div className="vp-actions">
            <button
              className="vp-btn vp-btn-secondary"
              onClick={fetchUltimaEjecucion}
              disabled={!selectedProceso}
            >
              Ver última ejecución
            </button>

            <button
              className="vp-btn"
              onClick={ejecutarProceso}
              disabled={loading || !selectedProceso || selectedCompania === ""}
            >
              {loading ? "Ejecutando..." : "Ejecutar"}
            </button>
          </div>
        </div>

        <div className="vp-toolbar-right">
          <div className="vp-ultima">
            <span className="vp-ultima-label">Última ejecución</span>
            <span className="vp-ultima-value">
              {ultimaEjecucion ? String(ultimaEjecucion) : "—"}
            </span>
          </div>
        </div>
      </div>

      <div className="vp-section-header">
        <h2>Últimos logs</h2>
        <button className="vp-btn vp-btn-light" onClick={fetchLogs}>
          Actualizar
        </button>
      </div>

      <div className="vp-table-wrap">
        <table className="vp-table">
          <thead>
            <tr>
              <th>IDLogApp</th>
              <th>Fecha</th>
              <th>Descripción</th>
              <th>Tipo Error</th>
              <th>Argumentos</th>
              <th>Instancia</th>
              <th>Traceback</th>
            </tr>
          </thead>
          <tbody>
            {logs.map((log) => (
              <tr key={log.id}>
                <td className="vp-col-id">
                  <span className="vp-cell-inline">{log.idlog_app}</span>
                </td>
                <td className="vp-col-fecha">
                  <span className="vp-cell-inline">{log.fechaevento}</span>
                </td>
                <td className="vp-col-text">
                  <div className="vp-cell-scroll">{log.descripcion}</div>
                </td>
                <td className="vp-col-text">
                  <div className="vp-cell-scroll">{log.tipoerror}</div>
                </td>
                <td className="vp-col-text">
                  <div className="vp-cell-scroll">{log.argumentos}</div>
                </td>
                <td className="vp-col-text">
                  <div className="vp-cell-scroll">{log.instancia}</div>
                </td>
                <td className="vp-col-trace">
                  <div className="vp-cell-scroll">{log.trace}</div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VistaProcesos;
